import React from 'react';
import { Box } from '@components/Box';
import { TextPairing } from '@components/TextPairing';
import {
  TitleText,
  StyledGrid,
  StyledContentBox,
  StyledContentHeader,
  ExploreButton,
  StyledCTALink,
  StyledCloudImage,
  FindRoleBox,
  GetinTouchCTALink,
  StyledClickableBox,
} from './JoyTeams.styles';
import { useTranslation } from 'react-i18next';

export const JoyTeams: React.FC = () => {
  const { t } = useTranslation('careers');
  const joyTeamsData = t('joyTeams');
  const teams = t('joyTeams.teams');
  return (
    <Box paddingY={[10, 0]} paddingX={5}>
      <TitleText variant="calloutHed40" tagName="h2" color="neutra6" textAlign={'center'}>
        {joyTeamsData.title}
      </TitleText>
      <ExploreButton id="ExploreAllRoles" variant="primary" forwardedAs="a" href={t('allPostionsCta')}>
        {joyTeamsData.cta}
      </ExploreButton>
      <StyledGrid>
        {teams.map((team, index) => (
          <StyledClickableBox href={t('allPostionsCta')} id={`ExploreRolesDesign${index}`} key={index}>
            <StyledCloudImage src={team.image} />
            <StyledContentBox>
              <StyledContentHeader variant="featureCopy17" tagName="h2" color="neutra6" textAlign={'center'} marginBottom={4}>
                {team.title}
              </StyledContentHeader>
              <StyledCTALink tagName="span" variant="featureCopy17">
                {joyTeamsData.exploreRoles}
              </StyledCTALink>
            </StyledContentBox>
          </StyledClickableBox>
        ))}
      </StyledGrid>
      <FindRoleBox marginTop={9}>
        <TextPairing
          title={joyTeamsData.getInTouch.title}
          titleVariant="featureHed17"
          titleColor={'neutra6'}
          titleTagName="h2"
          body={joyTeamsData.getInTouch.body}
          bodyVariant="featureCopy17"
          bodyColor={'neutra5'}
        />
        <GetinTouchCTALink id="GetinTouch" href="mailto:hello@withjoy.com" typography="featureHed17">
          {joyTeamsData.getInTouch.cta}
        </GetinTouchCTALink>
      </FindRoleBox>
    </Box>
  );
};
